export const INIT_SIGNIN = "INIT_SIGNIN";
export const SIGNIN = "SIGNIN";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNIN_FAIL = "SIGNIN_FAIL";

export const INIT_ONBOARDING_GET = "INIT_ONBOARDING_GET";
export const ONBOARDING_GET = "ONBOARDING_GET";
export const ONBOARDING_GET_SUCCESS = "ONBOARDING_GET_SUCCESS";
export const ONBOARDING_GET_FAIL = "ONBOARDING_GET_FAIL";
export const INIT_ONBOARDING_UPDATE = "INIT_ONBOARDING_UPDATE";
export const ONBOARDING_UPDATE = "ONBOARDING_UPDATE";
export const ONBOARDING_UPDATE_SUCCESS = "ONBOARDING_UPDATE_SUCCESS";
export const ONBOARDING_UPDATE_FAIL = "ONBOARDING_UPDATE_FAIL";

export const INIT_SIGNUP = "INIT_SIGNUP";
export const SIGNUP = "SIGNUP";
export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAIL = "SIGNUP_FAIL";
export const SIGNUP_SUCCESS_RESET = "SIGNUP_SUCCESS_RESET";

export const SIGN_OUT = "SIGN_OUT";

export const INIT_TAGS = "INIT_TAGS";
export const GET_TAGS = "GET_TAGS";
export const GET_TAGS_SUCCESS = "GET_TAGS_SUCCESS";
export const GET_TAGS_ERROR = "GET_TAGS_ERROR";

export const INIT_MENTORS = "INIT_MENTORS";
export const GET_MENTORS = "GET_MENTORS";
export const MENTORS_SUCCESS = "MENTORS_SUCCESS";
export const MENTORS_FAIL = "MENTORS_FAIL";
export const INIT_INDUSTRY = "INIT_INDUSTRY";
export const GET_INDUSTRIES = "GET_INDUSTRIES";
export const GET_INDUSTRIES_SUCCESS = "GET_INDUSTRIES_SUCCESS";
export const GET_INDUSTRIES_FAIL = "GET_INDUSTRIES_FAIL";

export const INIT_SCENARIOS = "INIT_SCENARIOS";
export const GET_SCENARIOS = "GET_SCENARIOS";
export const GET_SCENARIOS_SUCCESS = "GET_SCENARIOS_SUCCESS";
export const GET_SCENARIOS_ERROR = "GET_SCENARIOS_ERROR";
export const INIT_SUBMIT_SCENARIOS = "INIT_SUBMIT_SCENARIOS";
export const SET_SCENARIOS = "SET_SCENARIOS";
export const SET_SCENARIOS_SUCCESS = "SET_SCENARIOS_SUCCESS";
export const SET_SCENARIOS_ERROR = "SET_SCENARIOS_ERROR";
export const RESET_SAVING_RESULT = "RESET_SAVING_RESULT";

export const INIT_RESULTS = "INIT_RESULTS";
export const GET_RESULTS = "GET_RESULTS";
export const GET_RESULTS_SUCCESS = "GET_RESULTS_SUCCESS";
export const GET_RESULTS_ERROR = "GET_RESULTS_ERROR";
export const INIT_RESULTS_DETAIL = "INIT_RESULTS_DETAIL";
export const GET_RESULTS_DETAIL = "GET_RESULTS_DETAIL";
export const GET_RESULTS_DETAIL_SUCCESS = "GET_RESULTS_DETAIL_SUCCESS";
export const GET_RESULTS_DETAIL_ERROR = "GET_RESULTS_DETAIL_ERROR";
export const INIT_SET_RESULTS = "INIT_SET_RESULTS";
export const SET_RESULTS = "SET_RESULTS";
export const SET_RESULTS_SUCCESS = "SET_RESULTS_SUCCESS";
export const SET_RESULTS_ERROR = "SET_RESULTS_ERROR";

export const INIT_CHECK_AFFILIATE = "INIT_CHECK_AFFILIATE";
export const CHECK_AFFILIATE = "CHECK_AFFILIATE";
export const CHECK_AFFILIATE_SUCCESS = "CHECK_AFFILIATE_SUCCESS";
export const CHECK_AFFILIATE_ERROR = "CHECK_AFFILIATE_ERROR";
export const CLEAR_STATE_AFFILIATE = "CLEAR_STATE_AFFILIATE";

export const INIT_INTERESTED_CAREER = "INIT_INTERESTED_CAREER"
export const INTERESTED_CAREER = "INTERESTED_CAREER"
export const INTERESTED_CAREER_SUCCESS = "INTERESTED_CAREER_SUCCESS"
export const INTERESTED_CAREER_ERROR = "INTERESTED_CAREER_ERROR"

export const INIT_RECOMMENDATIONS_QUESTION = "INIT_RECOMMENDATIONS_QUESTION";
export const GET_RECOMMENDATIONS_QUESTION = "GET_RECOMMENDATIONS_QUESTION";
export const GET_RECOMMENDATIONS_QUESTION_SUCCESS = "GET_RECOMMENDATIONS_QUESTION_SUCCESS";
export const GET_RECOMMENDATIONS_QUESTION_ERROR = "GET_RECOMMENDATIONS_QUESTION_ERROR";

export const INIT_GET_PRICING_PLAN = "INIT_GET_PRICING_PLAN";
export const GET_PLANS = "GET_PLANS";
export const GET_PLANS_SUCCESS = "GET_PLANS_SUCCESS";
export const GET_PLAN_ERROR = "GET_PLAN_ERROR";
export const INIT_SET_PRICING_PLAN = "INIT_SET_PRICING_PLAN";
export const SET_PLAN = "SET_PLAN";
export const SET_PLAN_SUCCESS = "SET_PLAN_SUCCESS";
export const SET_PLAN_ERROR = "SET_PLAN_ERROR";

export const INIT_GET_PROFILE = "INIT_GET_PROFILE";
export const GET_PROFILE = "GET_PROFILE";
export const GET_PROFILE_SUCCESS = "GET_PROFILE_SUCCESS";
export const GET_PROFILE_ERROR = "GET_PROFILE_ERROR";
export const INIT_SET_PROFILE = "INIT_SET_PROFILE";
export const SET_PROFILE = "SET_PROFILE";
export const SET_PROFILE_SUCCESS = "SET_PROFILE_SUCCESS";
export const SET_PROFILE_ERROR = "SET_PROFILE_ERROR";

export const INIT_SET_PROFILE_PASSWORD = "INIT_SET_PROFILE_PASSWORD";
export const SET_PROFILE_PASSWORD = "SET_PROFILE_PASSWORD";
export const SET_PROFILE_PASSWORD_SUCCESS = "SET_PROFILE_PASSWORD_SUCCESS";
export const SET_PROFILE_PASSWORD_ERROR = "SET_PROFILE_PASSWORD_ERROR";

export const INIT_GET_RECOMMENDATIONS = "INIT_GET_RECOMMENDATIONS";
export const GET_RECOMMENDATIONS = "GET_RECOMMENDATIONS";
export const GET_RECOMMENDATIONS_SUCCESS = "GET_RECOMMENDATIONS_SUCCESS";
export const GET_RECOMMENDATIONS_ERROR = "GET_RECOMMENDATIONS_ERROR";

export const INIT_GET_FEEDBACKS = "INIT_GET_FEEDBACKS"
export const GET_FEEDBACKS = "GET_FEEDBACKS"
export const GET_FEEDBACKS_SUCCESS = "GET_FEEDBACKS_SUCCESS"
export const GET_FEEDBACKS_ERROR = "GET_FEEDBACKS_ERROR"


export const INIT_GET_SESSIONS = "INIT_GET_SESSIONS"
export const GET_SESSIONS = "GET_SESSIONS"
export const GET_SESSIONS_SUCCESS = "GET_SESSIONS_SUCCESS"
export const GET_SESSIONS_ERROR = "GET_SESSIONS_ERROR"

export const INIT_GET_QUOTES = "INIT_GET_QUOTES"
export const GET_QUOTES = "GET_QUOTES"
export const GET_QUOTES_SUCCESS = "GET_QUOTES_SUCCESS"
export const GET_QUOTES_ERROR = "GET_QUOTES_ERROR"


export const INIT_GET_STUDENT_RESOURCES = "INIT_GET_STUDENT_RESOURCES"
export const GET_STUDENT_RESOURCES = "GET_STUDENT_RESOURCES"
export const GET_STUDENT_RESOURCES_SUCCESS = "GET_STUDENT_RESOURCES_SUCCESS"
export const GET_STUDENT_RESOURCES_ERROR = "GET_STUDENT_RESOURCES_ERROR"
export const INIT_GET_STUDENT_RESOURCES_GREAT_FINDS = "INIT_GET_STUDENT_RESOURCES_GREAT_FINDS"
export const GET_STUDENT_RESOURCES_GREAT_FINDS = "GET_STUDENT_RESOURCES_GREAT_FINDS"
export const GET_STUDENT_RESOURCES_GREAT_FINDS_SUCCESS = "GET_STUDENT_RESOURCES_GREAT_FINDS_SUCCESS"
export const GET_STUDENT_RESOURCES_GREAT_FINDS_ERROR = "GET_STUDENT_RESOURCES_GREAT_FINDS_ERROR"


export const CHAT_LOAD_SUCCESS = "CHAT_LOAD_SUCCESS"
export const INIT_GET_AI_COMPANIONS = "INIT_GET_AI_COMPANIONS"
export const GET_AI_COMPANIONS = "GET_AI_COMPANIONS"
export const GET_AI_COMPANIONS_SUCCESS = "GET_AI_COMPANIONS_SUCCESS"
export const GET_AI_COMPANIONS_SINGLE_SUCCESS = "GET_AI_COMPANIONS_SINGLE_SUCCESS"
export const GET_AI_COMPANIONS_ERROR = "GET_AI_COMPANIONS_ERROR"
export const ADD_NEW_AI_COMPANIONS_CHAT = "ADD_NEW_AI_COMPANIONS_CHAT"
export const GET_AI_COMPANIONS_CHAT_HISTORY_SUCCESS = "GET_AI_COMPANIONS_CHAT_HISTORY_SUCCESS"
export const GET_AI_COMPANIONS_CHAT_HISTORY_ERROR = "GET_AI_COMPANIONS_CHAT_HISTORY_ERROR"
export const CLEAR_AI_COMPANIONS_CHAT = "CLEAR_AI_COMPANIONS_CHAT"
export const SEND_AI_COMPANIONS_CHAT = "SEND_AI_COMPANIONS_CHAT"
export const SEND_AI_COMPANIONS_CHAT_SUCCESS = "SEND_AI_COMPANIONS_CHAT_SUCCESS"
export const SEND_AI_COMPANIONS_CHAT_ERROR = "SEND_AI_COMPANIONS_CHAT_ERROR"
export const AI_COMPANIONS_CHAT_STREAM_START = "AI_COMPANIONS_CHAT_STREAM_START"
export const AI_COMPANIONS_CHAT_STREAM_DELTA = "AI_COMPANIONS_CHAT_STREAM_DELTA"
export const AI_COMPANIONS_CHAT_STREAM_DONE = "AI_COMPANIONS_CHAT_STREAM_DONE"
export const INIT_GET_AI_COMPANIONS_CHAT_HISTORY = "INIT_GET_AI_COMPANIONS_CHAT_HISTORY"
export const UPDATE_AI_COMPANIONS_CHAT_FEEDBACK = "UPDATE_AI_COMPANIONS_CHAT_FEEDBACK"
export const UPDATE_AI_COMPANIONS_CHAT_FEEDBACK_SUCCESS = "UPDATE_AI_COMPANIONS_CHAT_FEEDBACK_SUCCESS"

export const ADD_DATE_AI_CHAT = "ADD_DATE_AI_CHAT"

export const REMOVE_CHAT_HISTORY_LOADED = "REMOVE_CHAT_HISTORY"



export const INIT_GET_STRENGTHS = "INIT_GET_STRENGTHS"
export const GET_STRENGTHS = "GET_STRENGTHS"
export const GET_STRENGTHS_SUCCESS = "GET_STRENGTHS_SUCCESS"
export const GET_STRENGTHS_ERROR = "GET_STRENGTHS_ERROR"

export const GET_CAREERS_REQUEST = "GET_CAREERS_REQUEST"
export const GET_CAREERS_SUCCESS = "GET_CAREERS_SUCCESS"
export const GET_CAREERS_ERROR = "GET_CAREERS_ERROR"
export const SET_CAREERS_REQUEST = "SET_CAREERS_REQUEST"
export const SET_CAREERS_SUCCESS = "SET_CAREERS_SUCCESS"
export const SET_CAREERS_ERROR = "SET_CAREERS_ERROR"
export const CLEAR_CAREERS = "CLEAR_CAREERS"


// action types for action plan
export const SET_GENERATE_IDEAS = "SET_GENERATE_IDEAS"
export const SET_GENERATE_IDEAS_SUCCESS = "SET_GENERATE_IDEAS_SUCCESS"
export const SET_GENERATE_IDEAS_ERROR = "SET_GENERATE_IDEAS_ERROR"
export const SET_GENERATE_IDEAS_STREAM_START = "SET_GENERATE_IDEAS_STREAM_START"
export const SET_GENERATE_IDEAS_STREAM_DELTA = "SET_GENERATE_IDEAS_STREAM_DELTA"
export const SET_GENERATE_IDEAS_STREAM_DONE = "SET_GENERATE_IDEAS_STREAM_DONE"
export const SET_GENERATE_IDEAS_STREAM_ERROR = "SET_GENERATE_IDEAS_STREAM_ERROR"

export const INIT_GET_TERMS = "INIT_GET_TERMS"
export const GET_TERMS = "GET_TERMS"
export const GET_TERMS_SUCCESS = "GET_TERMS_SUCCESS"
export const GET_TERMS_ERROR = "GET_TERMS_ERROR"

export const INIT_START_ACTION_PLAN = "INIT_START_ACTION_PLAN"
export const START_ACTION_PLAN = "START_ACTION_PLAN"
export const START_ACTION_PLAN_SUCCESS = "START_ACTION_PLAN_SUCCESS"
export const START_ACTION_PLAN_ERROR = "START_ACTION_PLAN_ERROR"

export const SET_TERMS = "SET_TERMS"
export const SET_TERMS_SUCCESS = "SET_TERMS_SUCCESS"
export const SET_TERMS_ERROR = "SET_TERMS_ERROR"

export const DELETE_TERMS = "DELETE_TERMS"
export const DELETE_TERMS_SUCCESS = "DELETE_TERMS_SUCCESS"
export const DELETE_TERMS_ERROR = "DELETE_TERMS_ERROR"  

export const DOWNLOAD_ACTION = "DOWNLOAD_ACTION"
export const DOWNLOAD_ACTION_SUCCESS = "DOWNLOAD_ACTION_SUCCESS"
export const DOWNLOAD_ACTION_ERROR = "DOWNLOAD_ACTION_ERROR"  

export const REORDER_ACTION_TERM = "REORDER_ACTION_TERM"
export const REORDER_ACTION_TERM_SUCCESS = "REORDER_ACTION_TERM_SUCCESS"
export const REORDER_ACTION_TERM_ERROR = "REORDER_ACTION_TERM_ERROR"

export const INIT_FETCH_PROMPT_STATUS = "INIT_FETCH_PROMPT_STATUS";
export const FETCH_PROMPT_STATUS = "FETCH_PROMPT_STATUS";
export const FETCH_PROMPT_STATUS_SUCCESS = "FETCH_PROMPT_STATUS_SUCCESS";
export const FETCH_PROMPT_STATUS_ERROR = "FETCH_PROMPT_STATUS_ERROR";
export const DISMISS_PROMPT = "DISMISS_PROMPT";
export const INIT_LOG_PROMPT = "INIT_LOG_PROMPT";
export const MARK_PROMPT_SHOWN_LOGGED = "MARK_PROMPT_SHOWN_LOGGED";
export const SET_PROMPT_SAVING = "SET_PROMPT_SAVING";
export const SET_PROMPT_SAVE_ERROR = "SET_PROMPT_SAVE_ERROR";
export const CLEAR_PROMPT_SAVE_ERROR = "CLEAR_PROMPT_SAVE_ERROR";
